export enum DriverPaymentMethod {
    CARD = 'CARD',
    CASH = 'CASH',
    TERMINAL = 'TERMINAL',
}
